<template>
  <div>
    <list
      row-key="MenuId"
      ref="list"
      unit="菜单"
      :expand-all-row="true"
      :page="false"
      :get-data-func="getDataFunc"
      :delete-func="api.delete"
      :show-query="true"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="状态">
          <!-- h -->
          <el-select v-model="params.Status" clearable>
            <el-option label="启用" :value="1"></el-option>
            <el-option label="禁用" :value="0"></el-option>
          </el-select>            
          <!-- h -->
        </el-form-item>
      </template>
      <template slot="query-bar">
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="MenuName" label="功能菜单" :width="$store.state.isMB?'180':'350'" />
        <el-table-column prop="Url" label="路径" min-width="110" />
        <el-table-column prop="Sn" label="排序" align="center" :width="$store.state.isMB?'65':'80'" sortable="custom" />

        <!-- h -->
        <el-table-column prop="Status" label="状态" align="center" :width="$store.state.isMB?'65':'80'" sortable="custom">
          <template slot-scope="scope">
            <el-tag :type="scope.row.Status == 1 ? 'primary' : 'danger'">{{scope.row.Status == 1 ? '启用' : '禁用'}}</el-tag>
          </template>
        </el-table-column>
        <!-- h -->

        <!-- <el-table-column prop="CreateTime" label="创建时间" align="center" :width="$store.state.isMB?'110':''" sortable="custom" /> -->
        <!-- <el-table-column prop="UpdateTime" label="更新时间" align="center" :width="$store.state.isMB?'110':''" sortable="custom" /> -->
        <!-- </el-table-column> -->
        <!-- slot[column] -->
        <slot name="column"></slot>
        <!--/ slot[column]-->
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list
  },
  data() {
    return {
      api: require("@/api/sy/menu").default,
      params: {
        Status: null // <!-- h -->
      },
      sourceData: null
    };
  },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve, reject) => {
         this.api.list(params).then(res => {     
          this.sourceData = res.Data;
          let Data = this.$commonJs.toTreeData(res.Data,"MenuId");
          resolve({ Data });
        });
      });
    }
  }
};
</script>